var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.urldata)?_c('Hander',{attrs:{"pagetwoimg":_vm.pagetwoimg,"pagethreeing":_vm.pagethreeing}}):_vm._e(),_c('router-view'),(_vm.urldata)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }